import { render, staticRenderFns } from "./Application.vue?vue&type=template&id=bfddc8be&scoped=true&"
import script from "./Application.vue?vue&type=script&setup=true&lang=js&"
export * from "./Application.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bfddc8be",
  null
  
)

export default component.exports